/**
 * RESPONSIBILITY: draw the Visit page's banner.
 *
 * The About page's banner, by class: a picture behind a dimmed layer with the title over
 * it. The same classes rather than a second copy of the rules, so the two page heads can
 * never drift into looking like different sites.
 */
import type { VisitHeroSection } from '@app/sections';
import { Picture } from '../commons/Picture';
import { Crumbs } from '../commons/Crumbs';

export function VisitHero({ c }: { c: VisitHeroSection }) {
  return (
    <>
      <Crumbs trail={[{ label: c.heading }]} />
      <section className="ab-hero">
        <Picture value={c.image} alt={c.image?.alt} className="ab-hero__img" />
        <span className="ab-hero__dim" aria-hidden="true" />
        <div className="wrap ab-hero__content">
          {c.eyebrow && <p className="ab-hero__eyebrow">{c.eyebrow}</p>}
          <h1 className="ab-hero__h1">{c.heading}</h1>
          {c.intro && <p className="ab-hero__sub">{c.intro}</p>}
        </div>
      </section>
    </>
  );
}
